// extracted by mini-css-extract-plugin
module.exports = {"role":"PxHUd","roleName":"_1RpyF"};